import { useQuery } from "@tanstack/react-query";
import { apiClient } from "@/services/api";

export function useTrackLayout(trackId: string) {
  return useQuery({
    queryKey: ["trackLayout", trackId],
    queryFn: () => apiClient.getTrackLayout(trackId),
    enabled: !!trackId,
    staleTime: 5 * 60 * 1000, // Track layouts rarely change, cache for 5 minutes
    gcTime: 30 * 60 * 1000, // Keep in cache for 30 minutes
    retry: 2,
  });
}
